import axios from 'axios';

import orderService from './orderService';

const API_URL = process.env.REACT_APP_API_URL;

axios.defaults.baseURL = API_URL;

export { orderService };